import React from 'react';
import Image from 'next/image';
import { Stack, Typography, useTheme } from '@mui/material';
import { Box } from '@mui/system';

import { Container } from '@/components/layout';

const DATA = [
  {
    image: {
      src: '/images/press-center/w3-silver-award.png',
      width: '172px',
      height: '79.63px',
    },
    title: 'W3 Silver Award',
    description: 'Health & Wellness Video Marketing 2023',
  },
  {
    image: {
      src: '/images/press-center/ignite-award.png',
      width: '172px',
      height: '79.63px',
    },
    title: 'Ignite Award',
    description: 'Pitch Competition Winner 2024',
  },
  {
    image: {
      src: '/images/press-center/trinet-award.png',
      width: '172px',
      height: '79.63px',
    },
    title: 'TriNet',
    description: 'Pitch Competition Winner 2024',
  },
  {
    image: {
      src: '/images/press-center/aarp-award.png',
      width: '172px',
      height: '79.63px',
    },
    title: 'AARP',
    description: 'Pitch Competition Winner 2024',
  },
  {
    image: {
      src: '/images/press-center/techstars-award.png',
      width: '172px',
      height: '60.99px',
    },
    title: 'TechStars_',
    description: 'Startup Competition Winner 2021',
  },
];

function AwardItem({
  image,
  title,
  description,
}: {
  key: string;
  image: {
    src: string;
    width: string;
    height: string;
  };
  title: string;
  description: string;
}) {
  const theme = useTheme();

  return (
    <Stack
      sx={{
        width: { xs: '100%', sm: '366px' },
        backgroundColor: theme.palette.grey[100],
        alignItems: 'center',
        borderRadius: theme.spacing(2),
      }}
    >
      <Stack
        sx={{
          width: '100%',
          height: theme.spacing(26.25),
          paddingY: theme.spacing(3.17),
          borderBottom: '1px solid #B0B2BB',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box width={image.width} height={image.height} position="relative">
          <Image
            src={image.src}
            layout="fill"
            objectFit="contain"
            objectPosition="center"
          />
        </Box>
      </Stack>

      <Stack
        sx={{
          gap: theme.spacing(2),
          padding: theme.spacing(4.5, 12.5, 6),
        }}
      >
        <Typography
          fontSize="1.4375rem !important"
          lineHeight="1.4 !important"
          variant="h3"
          color="#52545F"
          textAlign="center"
        >
          {title}
        </Typography>

        <Typography
          fontSize="0.875rem !important"
          lineHeight="1.4 !important"
          variant="body2"
          color="#52545F"
          textAlign="center"
        >
          {description}
        </Typography>
      </Stack>
    </Stack>
  );
}

function OurAwards() {
  const theme = useTheme();

  return (
    <Stack
      sx={{
        gap: theme.spacing(8),
        paddingTop: { xs: theme.spacing(8), md: theme.spacing(10) },
        paddingBottom: { xs: theme.spacing(8), md: theme.spacing(15) },
        backgroundColor: theme.palette.common.white,
      }}
    >
      <Typography
        fontSize="2.375rem !important"
        lineHeight="1.2 !important"
        variant="h2"
        color="#52545F"
        textAlign="center"
      >
        Our Awards
      </Typography>

      <Container>
        <Stack
          sx={{
            flexDirection: { xs: 'column', sm: 'row' },
            flexWrap: 'wrap',
            rowGap: { xs: theme.spacing(6), md: theme.spacing(8) },
            columnGap: theme.spacing(8),
            justifyContent: 'center',
          }}
        >
          {DATA.map((item) => (
            <AwardItem key={item.title} {...item} />
          ))}
        </Stack>
      </Container>
    </Stack>
  );
}

export default OurAwards;
